"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFSTCalcProfitUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
exports.OrderFSTCalcProfitUtils = {
    _calcFutureSmartTradeProfit(item, basesTickers) {
        const innerOrder = item.exchangeFSTOrder;
        if (innerOrder === undefined || item.exchangeFSTOrder === undefined) {
            return item;
        }
        const unRealizedProfit = innerOrder.portfolio.reduce((sum, v) => {
            var _a;
            const avgPrice = item.isRunning && !new trade_utils_lib_1.SafeDecimal(v.qty_long).add(new trade_utils_lib_1.SafeDecimal(v.qty_short)).equals(0)
                ? new trade_utils_lib_1.SafeDecimal(v.amount_long)
                    .add(new trade_utils_lib_1.SafeDecimal(v.amount_short))
                    .add(new trade_utils_lib_1.SafeDecimal(v.amount_settle))
                    .div(new trade_utils_lib_1.SafeDecimal(v.qty_long).add(new trade_utils_lib_1.SafeDecimal(v.qty_short)))
                    .mul(-1)
                : 0;
            const currentPrice = item.isRunning
                ? (_a = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((ticker) => ticker.base === v.base && ticker.quote === item.quote)) === null || _a === void 0 ? void 0 : _a.latest
                : 0;
            // 临时订单qty_long + qty_short 为0 ，currentPrice 取值不重要
            if (currentPrice !== undefined) {
                return new trade_utils_lib_1.SafeDecimal(currentPrice)
                    .sub(avgPrice)
                    .mul(new trade_utils_lib_1.SafeDecimal(v.qty_long).add(new trade_utils_lib_1.SafeDecimal(v.qty_short)))
                    .add(sum)
                    .toNumber();
            }
            else {
                return sum;
            }
        }, 0);
        const investCost = new trade_utils_lib_1.SafeDecimal(innerOrder.quote_invest)
            .add(new trade_utils_lib_1.SafeDecimal(innerOrder.transfer_in))
            .sub(new trade_utils_lib_1.SafeDecimal(innerOrder.transfer_out));
        const totalProfit = trade_utils_lib_1.SafeDecimal.max(investCost.mul(-1), new trade_utils_lib_1.SafeDecimal(innerOrder.quote_amount).add(unRealizedProfit).sub(investCost));
        item.exchangeFSTOrder.unRealizedProfit = unRealizedProfit;
        item.exchangeFSTOrder.unrealizedProfitPercent = new trade_utils_lib_1.SafeDecimal(unRealizedProfit)
            .div(new trade_utils_lib_1.SafeDecimal(innerOrder.quote_invest))
            .mul(100)
            .toNumber();
        item.exchangeFSTOrder.totalProfit = totalProfit.toNumber();
        item.exchangeFSTOrder.totalProfitPercent = totalProfit.div(new trade_utils_lib_1.SafeDecimal(innerOrder.quote_invest)).mul(100).toNumber();
        return item;
    },
};
